import {AxiosResponse} from 'axios';

import axios from '@/core/tools/axios';

export default class ArticleService {
  static getArticles(id: string): Promise<AxiosResponse> {
    return axios.get(`/articles/${id}`);
  }
}
